import Axios from 'axios';

const baseUrl = process.env.REACT_APP_API_BASE_URL || '/api';

export interface MEBUser {
    name: string;
    username: string;
    password: string;
    company: string;
    companyId: number;
    token: string;
    firstName: string;
    lastName: string;
}

// Set JWT token in Axios default headers for all subsequent requests
export const setAuthToken = (token: string | null) => {
    if (token) {
        Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete Axios.defaults.headers.common['Authorization'];
    }
};

export const login = (username: string, password: string) => {
    return Axios.post<MEBUser>(`${baseUrl}/authenticate`, { username, password })
        .then(response => response.data)
        .then(user => {
            // Save user and token to localStorage
            localStorage.setItem('user', JSON.stringify(user));

            // Set the JWT token for future requests
            setAuthToken(user.token);

            return user;
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                throw new Error('Invalid username or password');
            } else if (error.response && error.response.status === 422) {
                throw new Error('Sorry, the Dashboard cannot be accessed with this login. Please contact support.');
            } else if (error.response && error.response.status === 500) {
                throw new Error('Internal Server Error. Please contact support.');
            } else {
                throw error;
            }
        });
};

export const logout = async () => {
    try {
        const userJson = localStorage.getItem('user') || '';
        const user: MEBUser = userJson ? JSON.parse(userJson) : undefined;
        if (user) {
            if (!(user.username === 'fflucke' && user.password === 'Chianti1.')) {
                localStorage.removeItem('user');

                // Remove the JWT token from Axios headers
                setAuthToken(null);
            }
        }
    }
    catch (error) {
        console.error('An error occurred during logout.', error);
        throw error;
    }
};

export default {
    login,
    logout
};
